<template>
    <div class="master-section iconsrow row col-12 col-md-10 offset-1 justify-content-between px-0 px-md-1 mb-40px icon-row-layout mb-md-60px">
        <div class="item_icon icon col-12 col-md-4" v-for="(item, id_item) in icon_rows" :key="id_item">
            <a :target="item.url.target || '_self'" :href="item.url.url"> 
                <img class="img-fluid mb-30px" :src="item.icon" alt="">
                <h3>{{ item.title }}</h3> 
            </a>
        </div>
    </div>
</template>
<script lang="ts" setup>
    const props = defineProps(["data"]);
    const icon_rows = computed(() => props.data);
</script>